export default {
    INPUT: 'input',
    MULTI_SELECT: 'multi-select',
    SELECT: 'select',
    TEXTAREA: 'textarea',
    FIELD_GROUP_REPEATER: 'FIELD_GROUP_REPEATER'
};
